<template>
  <div class="table_card">
    <div class="providers">

      <div class="providers__providers_list">
        <div
          class="providers__providers_list--header_container"
          :style="creating_provider ? 'padding-bottom: 10px' : ''">

          <div class="providers__providers_list--title">
            <span>Proveedor</span>
            <span>Descripción</span>
          </div>

          <div class="providers__new_provider" v-if="providers.length == 0 || creating_provider">
            <input
              style="width: 43%;"
              type="text"
              placeholder="Ingresar"
              v-model="new_provider.name">

            <input
              style="width: 56%;"
              type="text"
              placeholder="Ingresar"
              v-model="new_provider.description">

            <span
              class="providers__new_provider--add_btn"
              v-if="creating_provider"
              @click="addNewProvider()">
              Agregar
            </span>
          </div>
        </div>

        <v-divider v-if="creating_provider"></v-divider>

        <div
          class="providers__providers_list--container"
          :style="creating_provider ? 'margin: 30px 0 60px 0;' : ''"
          v-if="providers.length > 0">

          <div
            class="providers__providers_list--provider"
            v-for="provider in providers"
            @click="toggleSelectedProvider(provider.id)">

            <span
              class="providers__providers_list--provider_name"
              :style="provider.id == selected_provider ? 'background-color: #1476FB; color: white;' : ''"
              :title="provider.attributes.name">
              {{ provider.attributes.name }}
            </span>
            <span
              class="providers__providers_list--provider_description"
              :title="provider.attributes.description">
              {{ provider.attributes.description }}
            </span>
          </div>

        </div>

        <span
          class="providers__providers_list--add_btn"
          v-if="!creating_provider"
          @click="creating_provider = true">
          Agregar
        </span>
      </div>

      <v-divider vertical></v-divider>

      <div
        class="providers__provider_info"
        v-if="selected_provider_info != null">

        <div
          class="providers__provider_info--container">

          <span class="providers__provider_info--edit_btn" @click="editProviderInfo()">
            {{ editing_provider ? 'Guardar' : 'Editar' }}
          </span>

          <label>Proveedor</label>
          <input
            class="providers__provider_info--provider_name provider_info_input"
            type="text"
            :style="editing_provider ? 'border: 1px solid;' : 'background-color: #f0f2f5;'"
            :disabled="!editing_provider"
            v-model="selected_provider_info.name">

          <br>

          <label>Descripción</label>
          <input
            class="providers__provider_info--provider_description provider_info_input"
            type="text"
            :style="editing_provider ? 'border: 1px solid;' : 'background-color: #f0f2f5;'"
            :disabled="!editing_provider"
            v-model="selected_provider_info.description">

          <br>

          <label>Contacto</label>
          <input
            class="providers__provider_info--provider_contact_name provider_info_input"
            type="text"
            :style="editing_provider ? 'border: 1px solid;' : 'background-color: #f0f2f5;'"
            :disabled="!editing_provider"
            v-model="selected_provider_info.contact_name">

          <label>Celular</label>
          <input
            class="providers__provider_info--provider_phone provider_info_input"
            type="number"
            :style="editing_provider ? 'border: 1px solid;' : 'background-color: #f0f2f5;'"
            :disabled="!editing_provider"
            v-model="selected_provider_info.phone">

          <br>

          <label>Email</label>
          <input
            class="providers__provider_info--provider_email provider_info_input"
            type="text"
            :style="editing_provider ? 'border: 1px solid;' : 'background-color: #f0f2f5;'"
            :disabled="!editing_provider"
            v-model="selected_provider_info.email">

          <br>

          <label>Inicio</label>
          <input
            class="providers__provider_info--provider_contract_start provider_info_input"
            type="date"
            style="border: 1px solid;"
            v-model="selected_provider_info.contract_start"
            v-if="editing_provider">

          <input
            class="providers__provider_info--provider_contract_start provider_info_input"
            style="background-color: #f0f2f5;"
            disabled
            :value="formatted_contract_start_date"
            v-else>

          <label>Fin</label>
          <input
            class="providers__provider_info--provider_contract_termination provider_info_input"
            type="date"
            style="border: 1px solid;"
            v-model="selected_provider_info.contract_termination"
            v-if="editing_provider">

          <input
            class="providers__provider_info--provider_contract_termination provider_info_input"
            style="background-color: #f0f2f5;"
            disabled
            :value="formatted_contract_termination_date"
            v-else>
        </div>

        <div
          class="providers__provider_staff">

          <span style="font-weight: 600;">{{ creating_staff ? 'Nuevo funcionario' : 'Funcionarios' }}</span>
          <span class="providers__provider_staff--add_btn" @click="toggleStaffCard()" v-if="!editing_provider">
            {{ creating_staff || editing_staff ? 'Cancelar' : 'Agregar' }}
          </span>

          <div class="providers__provider_staff--card" v-if="creating_staff">
            <div class="providers__provider_staff--name">

              <div class="providers__provider_staff--photo">
                <label for="staff_avatar_input" class="providers__provider_staff--avatar_img">
                  <img :src="temporal_profile_photo" alt="profile photo" v-if="temporal_profile_photo != ''">
                  <span class="material-icons" style="font-size: 18px;" v-else>
                    add_photo_alternate
                  </span>
                  <input
                    type="file"
                    id="staff_avatar_input"
                    style="display: none;"
                    @change="uploadStaffProfilePhoto($event.target.files[0])">
                </label>
              </div>

              <input
                type="text"
                placeholder="Ingresar Nombre"
                v-model="new_staff.name">

              <div class="providers__provider_staff--new_staff_btn" @click="addNewStaff()">
                <span class="material-icons">save</span>
                <span style="font-size: 10px;">Guardar</span>
              </div>
            </div>

            <div class="providers__provider_staff--documents">
              <div
                class="providers__provider_staff--document_card"
                v-for="(document, index) in new_staff.documents"
                :style="document.expiration_date == '' || document.expiration_date <= current_date || document.support_file == '' ?
                'background-color: #ff4040;' : 'background-color: #70ba70'"
                @click="showCreateDocumentModal(document, index)">

                <span :title="document.document_type">{{ document.document_type }}</span>
                <span style="font-size: 12px;">{{ document.expiration_date | moment("DD MMM YY") }}</span>

              </div>

              <div class="providers__provider_staff--add_new_document" @click="showCreateDocumentModal()">
                <span class="material-icons">
                  add
                </span>
              </div>
            </div>

          </div>

          <div
            class="providers__provider_staff--list" v-if="staff.length > 0">
            <div
              class="providers__provider_staff--card"
              v-for="s in staff">

              <div class="providers__provider_staff--name" v-if="s.id != selected_staff">
                <div class="providers__provider_staff--photo">
                  <span class="providers__provider_staff--avatar_img" style="cursor: auto;">
                    <img :src="s.attributes.photo.support_file.url" alt="staff profile photo" v-if="s.attributes.photo != null">
                  </span>
                </div>

                <span>{{ s.attributes.name }}</span>

                <span
                  v-if="!creating_staff && !editing_staff"
                  class="material-icons providers__provider_staff--edit_staff_btn"
                  @click="activeStaffEdition(s)">
                  edit
                </span>
              </div>

              <div class="providers__provider_staff--name" v-else>

                <div class="providers__provider_staff--photo">
                  <label for="staff_avatar_input" class="providers__provider_staff--avatar_img">
                    <img :src="temporal_profile_photo" alt="staff profile photo" v-if="temporal_profile_photo != ''">
                    <span class="material-icons" style="font-size: 18px;" v-else>
                      add_photo_alternate
                    </span>
                    <input
                      type="file"
                      id="staff_avatar_input"
                      style="display: none;"
                      @change="uploadStaffProfilePhoto($event.target.files[0])">
                  </label>
                </div>

                <input
                  type="text"
                  placeholder="Ingresar Nombre"
                  v-model="new_staff.name">

                <div class="providers__provider_staff--new_staff_btn" @click="editStaffInfo()">
                  <span class="material-icons">edit</span>
                  <span style="font-size: 10px;">Guardar</span>
                </div>
              </div>

              <div class="providers__provider_staff--documents" v-if="s.id != selected_staff">
                <div
                  class="providers__provider_staff--document_card"
                  v-for="document in s.attributes.documents"
                  @click="showViewDocumentModal(document)"
                  :style="document.expiration_date <= current_date || document.expiration_date == null || document.support_file.url == null ?
                  'background-color: #ff4040;' : 'background-color: #70ba70'">

                  <span :title="document.document_type" >{{ document.document_type }}</span>
                  <span style="font-size: 12px;">{{ document.expiration_date | moment("DD MMM YY") }}</span>

                </div>
              </div>

              <div class="providers__provider_staff--documents" v-else>
                <div
                  class="providers__provider_staff--document_card"
                  v-for="(document, index) in new_staff.documents"
                  @click="showCreateDocumentModal(document, index)"
                  :style="document.expiration_date <= current_date || document.expiration_date == '' || document.expiration_date == null || document.support_file == '' ?
                  'background-color: #ff4040;' : 'background-color: #70ba70'">

                  <span :title="document.document_type">{{ document.document_type }}</span>
                  <span style="font-size: 12px;">{{ document.expiration_date | moment("DD MMM YY") }}</span>

                </div>

                <div
                  class="providers__provider_staff--add_new_document"
                  @click="showCreateDocumentModal()">
                  <span class="material-icons">
                    add
                  </span>
                </div>
              </div>

              <div class="providers__provider_staff--deactive_staff_list" v-if="creating_staff || (editing_staff && s.id != selected_staff)"></div>

            </div>
          </div>

        </div>

        <div v-if="completed_provider_tasks.length > 0" class="providers__provider_info--container">
          <span style="font-weight: 600;">Gestión</span>
          <div
            class="providers__provider_info--provider_tasks">
            <div
              v-for="task in completed_provider_tasks"
              class="providers__provider_info--completed_task">
              - {{ task.attributes.task_start | moment('DD MMMM YYYY') }}
            </div>
          </div>
        </div>

      </div>
    </div>


    <!-- MODALS -->
    <v-dialog v-model="show_create_modal" max-width="500px" persistent>
      <div class="providers__staff_document_modal">
        <span class="providers__staff_document_modal--close_btn" @click="closeDocumentModal()">Cerrar</span>

        <div v-if="other_document">
          <label for="document_type_input">Tipo de documento:</label>
          <input
            class="providers__staff_document_modal--document_type"
            type="text"
            id="document_type_input"
            v-model="document_type_modal">
        </div>

        <div>
          <label>Fecha vencimiento:</label>
          <input
            class="providers__staff_document_modal--expiration_date"
            type="date"
            id="document_expiration_date_input"
            v-model="expiration_date_modal">
        </div>

        <div class="providers__staff_document_modal--support_file" v-if="support_file_modal != '' && (uploaded_files_modal[document_type_modal] || uploaded_file_modal)">
          <label>Soporte:</label>
          <span
            :title="uploaded_file_modal || uploaded_files_modal[document_type_modal]">
            {{ uploaded_file_modal || uploaded_files_modal[document_type_modal] }}
          </span>
        </div>

        <div class="providers__staff_document_modal--modal_actions" v-if="show_create_modal">
          <label for="document_support_input" class="providers__staff_document_modal--btn">
            Cargar archivo
            <input
              type="file"
              id="document_support_input"
              style="display: none; position: absolute;"
              accept="application/pdf"
              @change="uploadStaffDocument($event.target.files[0])">
          </label>

          <label class="providers__staff_document_modal--btn" @click="saveOrEditDocument()">Guardar</label>
        </div>
      </div>
    </v-dialog>

    <view-document-modal
      :show="show_view_modal"
      :info="modal_info"
      @close-modal="closeDocumentModal()">
    </view-document-modal>

  </div>
</template>

<script>
import ViewDocumentModal from "@/components/views/SGSST/providers/document_modals/ViewDocumentModal.vue"
import moment from "moment"

export default {
  components: {
    "view-document-modal": ViewDocumentModal
  },
  data(){
    return {
      providers: [],
      staff: [],
      completed_provider_tasks: [],
      creating_provider: false,
      creating_staff: false,
      editing_provider: false,
      editing_staff: false,
      current_date: new Date().toISOString().split("T")[0],
      new_provider: {
        name: '',
        description: ''
      },
      new_staff: {
        name: '',
        photo: '',
        documents: []
      },
      temporal_profile_photo: '',
      document_type_modal: '',
      expiration_date_modal: '',
      support_file_modal: '',
      uploaded_file_modal: '',
      uploaded_files_modal: {},
      selected_provider: '',
      selected_staff: '',
      selected_provider_info: null,
      selected_document: null,
      other_document: false,
      show_create_modal: false,
      show_view_modal: false,
      modal_info: null
    }
  },
  computed: {
    formatted_contract_start_date(){
      return this.selected_provider_info.contract_start ? moment(this.selected_provider_info.contract_start).format('DD MMMM YYYY') : ''
    },
    formatted_contract_termination_date(){
      return this.selected_provider_info.contract_termination ? moment(this.selected_provider_info.contract_termination).format('DD MMMM YYYY') : ''
    }
  },
  methods: {
    uploadStaffProfilePhoto(photo){
      try {
        if(photo != undefined){
          const reader = new FileReader()
          const extension = photo.type.split('/')[1]

          if(photo.size > 500000) throw "El tamaño de la imagen no debe ser mayor a 500KB"
          if(extension != 'jpg' && extension != 'jpeg') throw "La imagen debe estar en formato jpg o jpeg"

          this.temporal_profile_photo = URL.createObjectURL(photo)
          reader.readAsDataURL(photo)
          reader.onload = () => {
            const base64 = reader.result
            this.new_staff.photo = base64
          }
        } else {
          this.temporal_profile_photo = ''
        }

      } catch(e) {
        alert(e)
      }
    },

    uploadStaffDocument(documentFile){
      try {
        if(typeof documentFile == 'object'){
          if(documentFile.size > 500000) throw "El archivo no puede superar el tamaño de 500KB"
          if(documentFile.type != 'application/pdf') throw "El archivo debe estar en formato PDF"

          this.uploaded_file_modal = documentFile.name
          this.support_file_modal = documentFile
        }
      } catch(e) {
        alert(e)
      }
    },

    convertPDF(){
      return new Promise((res, rej) => {
        try {
          const reader = new FileReader()
          reader.readAsDataURL(this.support_file_modal)
          reader.onload = () => {
            res(reader.result)
          }
        } catch(e) {
          res(this.support_file_modal)
        }
      })
    },

    toggleSelectedProvider(id){
      if(this.selected_provider != '' && this.selected_provider == id){
        this.selected_provider = ''
        this.selected_provider_info = null
      } else {
        this.selected_provider = id
        this.getProviderInfo()
        this.getCompletedProviderTasks()
        this.getProviderStaff()
        this.cleanUp()
      }
    },

    toggleStaffCard(){
      if(!this.creating_staff){
        if(this.editing_staff){
          this.new_staff.name = ''
          this.new_staff.photo = ''
          this.new_staff.documents = []
          this.temporal_profile_photo = ''
          this.document_type_modal = ''
          this.support_file_modal = ''
          this.expiration_date_modal = ''
          this.editing_staff = false
          this.selected_staff = ''

        } else {
          this.editing_provider = false
          this.creating_staff = true
          this.new_staff.documents = [
            {
              document_type: 'EPS',
              support_file: '',
              expiration_date: ''
            },
            {
              document_type: 'ARL',
              support_file: '',
              expiration_date: ''
            },
            {
              document_type: 'CEDULA',
              support_file: '',
              expiration_date: ''
            }
          ]
        }

      } else {
        this.creating_staff = false
        this.selected_document = null
        this.temporal_profile_photo = ''
        this.new_staff.name = ''
        this.new_staff.photo = ''
        this.new_staff.documents = []
        this.uploaded_files_modal = []
      }
    },

    activeStaffEdition(staff){
      this.editing_staff = true
      this.selected_staff = staff.id
      this.new_staff.name = staff.attributes.name
      this.temporal_profile_photo = staff.attributes.photo ? staff.attributes.photo.support_file.url : ''

      staff.attributes.documents.forEach(doc => {
        this.new_staff.documents.push({
          id: doc.id,
          document_type: doc.document_type,
          support_file: doc.support_file.url ? doc.support_file.url : '',
          expiration_date: doc.expiration_date
        })
      })
    },

    showCreateDocumentModal(doc, index = null){
      this.document_type_modal = ''
      this.support_file_modal = ''
      this.expiration_date_modal = ''
      this.uploaded_file_modal = ''
      this.show_create_modal = true
      this.selected_document = index
      this.other_document = index > 2 || index == null

      if(index != null){
        this.document_type_modal = doc.document_type
        this.support_file_modal = doc.support_file
        this.expiration_date_modal = doc.expiration_date
        this.uploaded_file_modal = this.uploaded_files_modal[doc.document_type]
      }
    },

    showViewDocumentModal(doc){
      this.modal_info = doc
      this.show_view_modal = true
    },

    closeDocumentModal(){
      this.show_view_modal = false
      this.show_create_modal = false
    },

    async saveOrEditDocument(){
      const base64 = await this.convertPDF()

      if(this.selected_document == null){
        if(this.document_type_modal.trim() != ''){
          this.new_staff.documents.push({
            document_type: this.document_type_modal.toUpperCase(),
            support_file: base64,
            expiration_date: this.expiration_date_modal
          })
          this.uploaded_files_modal[this.document_type_modal.toUpperCase()] = this.uploaded_file_modal
          this.show_create_modal = false
        } else alert("El documento que desea guardar debe tener un tipo de documento")

      } else {
        this.new_staff.documents[this.selected_document].document_type = this.document_type_modal.toUpperCase()
        this.new_staff.documents[this.selected_document].support_file = base64
        this.new_staff.documents[this.selected_document].expiration_date = this.expiration_date_modal
        this.uploaded_files_modal[this.document_type_modal.toUpperCase()] = this.uploaded_file_modal
        this.show_create_modal = false
      }
    },

    getProviders(){
      try {
        this.$http.get('providers', {
          params: {
            company_id: this.getCompany().id
          },
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }
        }).then(response => {
          this.providers = response.body.data
          this.creating_provider = response.body.data.length == 0

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })

      } catch(e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    getCompletedProviderTasks(){
      try {
        this.$http.get('providers/find_provider_tasks', {
          params: {
            provider_id: this.selected_provider
          },
          headers: {
            "Authorization": 'Bearer ' + this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }
        }).then(response => {
          this.completed_provider_tasks = response.body.data

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }


      } catch(e){
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    addNewProvider(){
      try {
        if(this.new_provider.name == '' || this.new_provider.description == ''){
          throw { message: "Por favor ingrese el nombre y descripción del proveedor que desea agregar" }
        }

        const data = {
          name: this.new_provider.name,
          description: this.new_provider.description
        }

        this.$http.post('providers', {
          data: this.encrypt(data).toString()
        },
        {
          params: {
            company_id: this.getCompany().id
          },
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.selected_provider = ''
          this.updateAlertMessage(response.body.ans)
          this.updateIsInAlert(true)
          this.getProviders()
          this.cleanUp()

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    getProviderInfo(){
      try {
        this.$http.get('providers/find_provider_info', {
          params: {
            provider_id: this.selected_provider
          },
          headers: {
            "Authorization": 'Bearer ' + this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }
        }).then(response => {
          this.selected_provider_info = {
            name: response.body.data.attributes.name,
            description: response.body.data.attributes.description,
            contact_name: response.body.data.attributes.provider_info.contact_name,
            phone: response.body.data.attributes.provider_info.phone,
            email: response.body.data.attributes.provider_info.email,
            contract_start: response.body.data.attributes.provider_info.contract_start,
            contract_termination: response.body.data.attributes.provider_info.contract_termination,
          }

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }

        }),function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e) {
        alert(e.message)
      }
    },

    editProviderInfo(){
      if(this.editing_provider){
        try {
          if(this.selected_provider_info.name == '' || this.selected_provider_info.description == ''){
            throw { message: "El proveedor debe tener nombre y descripción" }
          }

          if(this.selected_provider_info.contract_start > this.selected_provider_info.contract_termination){
            throw { message: "La fecha de terminación del contrato debe ser posterior a la fecha de inicio" }
          }

          this.$http.put('providers/edit_info', {
            data: this.encrypt(this.selected_provider_info).toString()
          },
          {
            params: {
              provider_id: this.selected_provider
            },
            headers: {
              "Authorization": 'Bearer ' + this.getUserToken(),
              "X-Device-ID": this.getDeviceId()
            }

          }).then(response => {
            this.selected_provider = response.body.data.id
            this.updateAlertMessage("Información del proveedor actualizada correctamente")
            this.updateIsInAlert(true)
            this.getProviders()
            this.getProviderInfo()
            this.getCompletedProviderTasks()
            this.editing_provider = false

            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }

          }),function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }

        } catch(e) {
          this.updateAlertMessage(e.message)
          this.updateIsInAlert(true)
        }

      } else {
        this.editing_provider = true
      }
    },

    addNewStaff(){
      try {
        if(this.new_staff.name == '') throw { message: "Por favor ingrese el nombre del funcionario que desea agregar" }

        this.$http.post('staff', {
          data: this.encrypt(this.new_staff).toString()
        },
        {
          params: {
            provider_id: this.selected_provider
          },
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.updateAlertMessage(response.body.ans)
          this.updateIsInAlert(true)
          this.getProviders()
          this.getProviderInfo()
          this.getCompletedProviderTasks()
          this.getProviderStaff()
          this.cleanUp()

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }

        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    getProviderStaff(){
      try {
        this.$http.get('staff', {
          params: {
            provider_id: this.selected_provider
          },
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.staff = response.body.data

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }
      } catch(e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    editStaffInfo(){
      try {
        if(this.new_staff.name == '') throw { message: "El nombre del funcionario no puede estar vacio" }

        this.$http.put('staff', {
          data: this.encrypt(this.new_staff).toString()
        },
        {
          params: {
            staff_id: this.selected_staff
          },
          headers: {
            "Authorization": 'Bearer '+this.getUserToken(),
            "X-Device-ID": this.getDeviceId()
          }

        }).then(response => {
          this.updateAlertMessage(response.body.ans)
          this.updateIsInAlert(true)
          this.getProviders()
          this.getProviderInfo()
          this.getCompletedProviderTasks()
          this.getProviderStaff()
          this.cleanUp()

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }), function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }

      } catch(e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true)
      }
    },

    cleanUp(){
      this.creating_provider = false
      this.creating_staff = false
      this.editing_provider = false
      this.editing_staff = false
      this.selected_staff = ''
      this.selected_provider_info = null
      this.new_provider.name = ''
      this.new_provider.description = ''
      this.new_staff.photo = ''
      this.new_staff.name = ''
      this.new_staff.documents = []
      this.staff = []
      this.temporal_profile_photo = ''
      this.uploaded_files_modal = []
    }
  },
  mounted(){
    this.getProviders()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/providers/Index.vue